import { cr } from "fire-wind-water";
import Checkbox from "ant-design-vue/lib/checkbox"; // 加载 JS
import "ant-design-vue/lib/checkbox/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Checkbox);
const checkboxImgMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldObj: {},
      isShow: false,
      title: "",
      desc: "",
      href: "",
      src: "",
      optionIds: [] //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请选择";
    }
    this.fieldObj = new window.$sk.Checkbox(this.field);
    cr.each(this.fieldObj.listOptions, b => {
      cr.each(this.fieldObj.options, u => {
        if (b.optionId == u.optionId) {
          b.picUrl = u.picUrl;
          b.isOther = u.isOther;
        }
      });
    });
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    cr.each(this.fieldValue, m => {
      const o = this.fieldObj.listOptions.filter(b => {
        return b.optionValue == m;
      })[0];
      this.fieldObj.setValue(o, true);
    });
  },
  methods: {
    handleChange(e) {
      const o = this.fieldObj.listOptions.filter(b => {
        return b.optionId == e.target.value;
      })[0];
      this.fieldObj.setValue(o, e.target.checked);
      let selectOptionId =[];
      this.fieldObj.listOptions.filter(b => {
        if(b.checked){
          selectOptionId.push(b.optionId);
        }
      });
      this.$emit("change",{
        type:this.field.type,
        value: selectOptionId.join(','),
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
    },
    showImg(src, title, desc, href) {
      this.isShow = true;
      this.title = title;
      this.desc = desc;
      this.href = href;
      this.src = src;
    },
    close() {
      this.isShow = false;
      this.title = "";
      this.desc = "";
      this.href = "";
      this.src = "";
    }
  }
};
export default checkboxImgMixin;
